import { render } from "./FloatRule.vue?vue&type=template&id=6b098d3c"
import script from "./FloatRule.vue?vue&type=script&lang=js"
export * from "./FloatRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__